import GtmEvent from '../analytics/GtmEvent';
import Cookies from '../utilities/Cookies';
// eslint-disable-next-line no-undef
const $ = jQuery;

class ReadyToLearnMoreForm {
	constructor() {
		this.formId = 5;
		this.gtmEventCategory = 'form';
		this.gtmEventLabel = 'Ready to Learn More Form';
		this.formShowed = false;
		this.startedInput = false;
		this.progressedToSecondStep = false;
		this.submittedForm = false;
		this.zipCodeData = [];
		this.currentSearch = 0;
		this.zipCodeApiResult = false;

		this.zipCode = $('#gform_5 .stride-zip-code input');
		this.districtCode = $('#gform_5 .stride-school-district-code');
		this.schoolCode = $('#gform_5 .stride-school-code');

		this.textPrivateOrCharterSchool = 'Private or Charter School';
	}

	init() {
		this.conditionallyLoadForm();
		this.addEventListeners();
	}

	addEventListeners() {
		this.addZipCodeEventListener();
		this.addDistrictCodeEventListener();
		this.addSchoolCodeEventListener();

		this.addGravityFormsSecondPageEventListener();
		this.addGravityFormsValidationErrorEventListener();
		this.addGravityFormsConfirmationEventListener();

		// GTM events
		this.setFormShowedEventListener();
		this.setStartInputEventListener();
		this.setNextStepEventListener();
		this.setFormSubmitEventListener();
	}

	conditionallyLoadForm() {
		const readyToLearnMoreCookie = Cookies.get('ready-to-learn-more');
		if (readyToLearnMoreCookie) {
			$('.sticky-cta-form').addClass('form-hidden');
		} else {
			$('.sticky-cta-form').removeClass('form-hidden');
		}
	}

	addZipCodeEventListener() {
		this.zipCode.on('keyup', () => {
			this.generateZipCodeData();
		});
	}

	addDistrictCodeEventListener() {
		this.districtCode.on('change', () => {
			this.setSchoolDropdownData();
		});
	}

	addSchoolCodeEventListener() {
		this.schoolCode.on('change', () => {
			const selectedSchoolId = this.schoolCode.find('option:selected').data('id');
			const selectedDistrictId = this.districtCode.find('option:selected').data('id');
			this.fillSchoolHiddenFieldData(selectedSchoolId, selectedDistrictId);
		});
	}

	generateZipCodeData() {
		const zipCode = this.zipCode.val();
		if (zipCode) {
			const zipCodeLength = zipCode.length;
			if (zipCodeLength === 5) {
				this.currentSearch++;
				const { currentSearch } = this;
				this.zipCode.addClass('stride-form-loading');
				$.ajax({
					type: 'post',
					dataType: 'json',
					// eslint-disable-next-line no-undef
					url: theme_args.admin_ajax,
					data: {
						action: 'zip_code_lookup',
						zipCode,
						currentSearch,
					},
					success: (data) => {
						this.zipCodeData = data;
						const districtDropdownInfo = [];
						if (data.districts) {
							data.districts.forEach((districtData) => {
								const districtInfo = {
									name: districtData.name,
									students: districtData.districtStudents,
									county: districtData.county,
									state: districtData.state,
									id: districtData.id,
								};
								districtDropdownInfo.push(districtInfo);
							});
							this.replaceTextWithSelectInput(this.districtCode);
							this.replaceTextWithSelectInput(this.schoolCode);
							this.fillSelect(this.districtCode, 'District', districtDropdownInfo);
							this.setSchoolDropdownData(this.districtCode);
							this.zipCodeApiResult = true;
						} else {
							this.zipCodeApiResult = false;
							this.replaceSelectWithTextInput(this.districtCode);
							this.districtCode.find('input').val('');
							this.replaceSelectWithTextInput(this.schoolCode);
							this.schoolCode.find('input').val('');
						}
					},
					fail: (xhr, status, error) => {
						console.error('AJAX request failed. Status:', status, 'Error:', error);
						this.zipCodeApiResult = false;
						// this.replaceSelectWithTextInput(this.districtCode);
						// this.replaceSelectWithTextInput(this.schoolCode);
					},
				});
			}
		}
	}

	replaceTextWithSelectInput(parentSelector) {
		const textInput = parentSelector.find('input');
		if (!(textInput.length > 0)) {
			return;
		}
		const select = $('<select></select>');

		$.each(textInput[0].attributes, function () {
			if (this.name !== 'type') {
				select.attr(this.name, this.value);
			}
		});

		textInput.replaceWith(select);
	}

	replaceSelectWithTextInput(parentSelector) {
		const selectElement = parentSelector.find('select');
		if (!(selectElement.length > 0)) {
			return;
		}
		const textInput = $('<input type="text">');

		$.each(selectElement[0].attributes, function () {
			if (this.name !== 'type') {
				textInput.attr(this.name, this.value);
			}
		});

		textInput.val();
		selectElement.replaceWith(textInput);
	}

	fillSelect(parentSelector, selectType, data = []) {
		$(parentSelector).find('option').remove();
		let html = `<option value="Select ${selectType}" disabled>Select ${selectType}</option>`;
		// data = this.sortAlphabetically(data);
		this.sortAlphabetically(data);
		for (let i = 0; i < data.length; i++) {
			html += `<option value="${data[i].name}" data-id="${data[i].id}">${data[i].name}</option>`;
		}
		html += `<option value="${this.textPrivateOrCharterSchool}" data-id="private-or-charter">Private or Charter School</option>`;
		$(parentSelector).find('select').html(html);
	}

	setSchoolDropdownData() {
		const selectedDistrictId = '';
		if (this.districtCode) {
			const selectedDistrictId = this.districtCode.find('option:selected').data('id');
			const schoolData = this.zipCodeData.schools;

			if (selectedDistrictId && selectedDistrictId !== 'private-or-charter') {
				const districtSchools = schoolData[selectedDistrictId];
				if (districtSchools) {
					this.fillSelect(this.schoolCode, 'School', districtSchools);
				} else {
					this.fillSelect(this.schoolCode, 'School', []);
				}
			}
		} else {
			this.fillSelect(this.schoolCode, 'School', []);
		}

		this.fillDistrictHiddenFieldData(selectedDistrictId);
	}

	fillDistrictHiddenFieldData(districtId) {
		if (this.zipCodeApiResult) {
			if (districtId && districtId !== 'private-or-charter') {
				const districtInfo = this.zipCodeData.districts.filter((value) => {
					return value.id === districtId;
				});
				const { name, state, county, students } = districtInfo[0];

				$('#field_1_19 input').val(name);
				$('#field_1_14 input').val(county);
				$('#field_1_16 input').val(state);
				$('#field_1_24 input').val(students);
			} else {
				$('#field_1_19 input').val(this.textPrivateOrCharterSchool);
				$('#field_1_14 input').val('');
				$('#field_1_16 input').val('');
				$('#field_1_24 input').val('');
			}
		} else {
			$('#field_1_19 input').val($('#field_1_11 input').val());
		}
	}

	fillSchoolHiddenFieldData(schoolId, districtId) {
		let schoolName = '';
		let schoolSize = '';
		let districtName = '';
		if (this.zipCodeApiResult) {
			if (districtId && districtId !== 'private-or-charter') {
				const districtInfo = this.zipCodeData.districts.filter((value) => {
					return value.id === districtId;
				});

				districtName = districtInfo[0].name;
			} else {
				districtName = this.textPrivateOrCharterSchool;
			}

			if (schoolId !== 'private-or-charter') {
				const districtData = this.zipCodeData.schools[districtId];
				const schoolInfo = districtData.filter((value) => {
					return value.id === schoolId;
				});

				const schoolData = schoolInfo[0];
				schoolName = schoolData.name;
				schoolSize = schoolData.buildingStudents;
			} else {
				schoolName = this.textPrivateOrCharterSchool;
				schoolSize = '';
			}
		} else {
			districtName = $('#field_1_11 input').val();
			schoolName = $('#field_1_10 input').val();
			schoolSize = '';
		}
		$('#field_1_18 input').val(schoolName);
		$('#field_1_17 input').val(schoolSize);
		$('#field_1_15 input').val(`${districtName} / ${schoolName}`);
	}

	sortAlphabetically(arrayData) {
		arrayData.sort((a, b) => {
			const textA = a.name.toUpperCase();
			const textB = b.name.toUpperCase();

			if (textA < textB) {
				return -1;
			}
			if (textA > textB) {
				return 1;
			}
			return 0;
		});

		return arrayData;
	}

	/**
	 * Generates the Zip Code data on Second Page Load
	 */
	addGravityFormsSecondPageEventListener() {
		$(document).on('gform_page_loaded', () => {
			this.zipCode = $('#gform_5 .stride-zip-code input');
			this.districtCode = $('#gform_5 .stride-school-district-code');
			this.schoolCode = $('#gform_5 .stride-school-code');
			this.addZipCodeEventListener();
			this.addDistrictCodeEventListener();
			this.generateZipCodeData();
		});
	}

	/**
	 * Generates the Zip Code data on Gravity Forms validation Error
	 */
	addGravityFormsValidationErrorEventListener() {
		$(document).on('gform_post_render', (e, form_id) => {
			if (form_id !== this.formId) {
				return;
			}
			if ($('.gform_wrapper').hasClass('gform_validation_error')) {
				this.zipCode = $('#gform_5 .stride-zip-code input');
				this.districtCode = $('#gform_5 .stride-school-district-code');
				this.schoolCode = $('#gform_5 .stride-school-code');
				this.zipCodeApiResult = false;
				this.fillDistrictHiddenFieldData();
				this.fillSchoolHiddenFieldData();
				this.addZipCodeEventListener();
				this.addDistrictCodeEventListener();
			}
		});
	}

	addGravityFormsConfirmationEventListener() {
		$(document).on('gform_confirmation_loaded', (event, form_id) => {
			if (form_id !== this.formId) {
				return;
			}
			$('.sticky-cta-form').addClass('gravity-confirmation');
			$('.sticky-cta-form__title').text('Success!');
			// prettier-ignore
			$('.gravity-confirmation .sticky-cta-form__toggle, .gravity-confirmation .sticky-cta-form__close-button').click(function () {
				$('.sticky-cta-form').removeClass('form-active').addClass('form-hidden');
			});
			this.addZipCodeEventListener();
		});
	}

	/**
	 * GTM event - Form Showed
	 */
	setFormShowedEventListener() {
		$('.sticky-cta-form__teaser').on('click', () => {
			if (!this.formShowed) {
				this.formShowed = true;
				GtmEvent(this.gtmEventCategory, 'Form Showed', this.gtmEventLabel);
			}
		});
	}

	/**
	 * GTM event - Started Input
	 */
	setStartInputEventListener() {
		// prettier-ignore
		$('.sticky-cta-form .gform_wrapper input, .sticky-cta-form .gform_wrapper select, .sticky-cta-form .gform_wrapper textarea').on('input change', () => {  // prettier-ignore
			if (!this.startedInput) {
				this.startedInput = true;
				GtmEvent(this.gtmEventCategory, 'Started Form Input', this.gtmEventLabel);
			}
		});
	}

	/**
	 * GTM event - Progressed To Second Page of the Form
	 */
	setNextStepEventListener() {
		$(document).on('gform_page_loaded', (event, form_id, current_page) => {
			if (this.progressedToSecondStep) {
				return;
			}

			if (form_id !== this.formId) {
				return;
			}

			if (parseInt(current_page, 10) === 2) {
				this.progressedToSecondStep = true;
				GtmEvent(this.gtmEventCategory, 'Progressed To Second Page', this.gtmEventLabel);
			}
		});
	}

	/**
	 * GTM event - Form Submitted
	 */
	setFormSubmitEventListener() {
		$(document).on(`gform_confirmation_loaded`, (e, form_id) => {
			if (this.submittedForm) {
				return;
			}

			// If its not the "Ready to learn more form"
			if (form_id !== this.formId) {
				return;
			}
			this.submittedForm = true;
			Cookies.set('ready-to-learn-more', 'true', 365);

			GtmEvent(this.gtmEventCategory, 'LeadSubmit', this.gtmEventLabel);
		});
	}
}

export default ReadyToLearnMoreForm;
